import {
  bridgeReady,
  registerHandler
} from '../core/old_bridge';

import {
  supportPrompt,
  promptSend
} from '../core/old_prompt';

import {
  extendSimple,
  isIos
} from './util';

import {
  getWindow,
  isStr,
  noop
} from '../util';

/**
 * _beatlesCommunicate 顺风车扩展协议实现之客户端调用前端
 * @param data
 * @param fn
 * @private
 */
function _beatlesCommunicate(data, fn) {
  if (data && data['header']) {
    var header = data['header'];
    var eventKey = header['event_key'];
    if (eventKey) {
      var event = document.createEvent('Event');
      event.initEvent(eventKey);
      event.data = JSON.parse(JSON.stringify(data));
      document.dispatchEvent(event);
    }
  }
  fn && fn('{"communitcate": "ok"}');
};

/**
 * 4.x和5.x 注册_beatlesCommunicate方法
 */
bridgeReady(function (bridge) {
  getWindow().DidiBeatlesJSBridge = bridge;
  isIos() && bridge.init && bridge.init();
  bridge._beatlesCommunicate = _beatlesCommunicate;
  // ios 使用
  if (isIos()) {
    registerHandler('_beatlesCommunicate', bridge._beatlesCommunicate);
  }
});

/**
 * Fusion 新容器 注册_beatlesCommunicate方法
 */
registerFusionPassiveBC();

function registerFusionPassiveBC() {
  if (getWindow().Fusion) {
    var Beatles = getWindow().Fusion.loadModule('Beatles');
    Beatles._beatlesCommunicate = _beatlesCommunicate;
  }
}

/**
 * 封装调用callHandler方法
 * @param name
 * @param param
 * @param callback
 */
export function callHandler(name, param, callback) {
  callback = callback || noop;
  if (supportPrompt()) {
    promptSend(name, param, callback);
  } else {
    bridgeReady((bridge) => {
      bridge.callHandler(name, param, (data) => {
        // 兼容data是字符串的情况
        if (isStr(data)) {
          data = JSON.parse(data);
        }
        callback.length === 1 ? callback(JSON.stringify(data)) : callback(null, data);
      });
    });
  }
}

/**
 * 封装beatlesCommunicate方法 走4.x协议
 * @param params
 */
export function beatlesCommunicate(params) {
  const eventKey = params.header.event_key;
  // ios initPushType要早于showEntrance调用，但是安卓要晚于showEntrance。历史原因。。。
  if (eventKey === 'initPushType') {
    let timeDelay = 360;
    if (isIos()) {
      timeDelay = 260;
    }
    setTimeout(function () {
      callHandler('beatlesCommunicate', params);
    }, timeDelay);
  } else {
    callHandler('beatlesCommunicate', params);
  }
}

/**
 * 进一步封装beatlesCommunicate协议使用方式
 * @param eventKey
 * @param bodyData
 * @param cb
 * @param callbackOnce
 */
export function callNative(eventKey, bodyData, cb, callbackOnce) {
  // 变量
  eventKey = eventKey || '';
  bodyData = bodyData || {};
  bodyData = extendSimple({}, bodyData);
  // 监听客户端调用_beatlesCommunicate，定义 "回调eventKey"
  if (cb) {
    // "回调eventKey" 数附加到bodyData中
    var callbackEventkey = 'event_key_' + Math.abs(~~(Math.random() * 1E10));
    extendSimple(bodyData, {
      callback: callbackEventkey
    });
    // alert(JSON.stringify(callbackEventkey));
    // 监听客户端回调事件
    listenNative(callbackEventkey, function (resObj) {
      cb(resObj);
    }, callbackOnce);
  }
  // 协议调用
  beatlesCommunicate({
    header: {
      event_id: 7,
      event_key: eventKey,
      event_type: 1,
      page_url: window.location.href
    },
    body: bodyData
  });
}

/**
 * 监听顺风车客户端调用js方法
 * @param eventKey
 * @param cb
 * @param callbackOnce
 */
export function listenNative(eventKey, cb, callbackOnce) {
  // 监听客户端调用_beatlesCommunicate事件
  var listener = function (e) {
    // callback
    var callbackBodyData;
    if (e && e.data && e.data.body) {
      try {
        callbackBodyData = JSON.parse(e.data.body);
      } catch (ex) {
        callbackBodyData = e.data.body;
      }
    }
    cb(callbackBodyData);
    // removeEventListener
    if (callbackOnce) {
      document.removeEventListener(eventKey, listener, false);
    }
  };
  document.addEventListener(eventKey, listener, false);
}



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgebeatles/beatles/call.js